import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminRouter from './components/admin/AdminRouter';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="*" element={<AdminRouter />} />
    </Routes>
  );
}

export default App;
